export const LookupConstants = {
  USER_TIMEFRAMES: "USER_TIMEFRAMES"
};
